import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';

export function ReceivablesLink({ invoiceId, disabled = false }) {
  const [active, setActive] = useState(false);
  useEffect(() => {
    let alive = true;
    authFetch('/incasari-scont/config').then(c => {
      if (alive) setActive(!!(c?.enabled && c?.can_read));
    }).catch(() => { if (alive) setActive(false); });
    return () => { alive = false; };
  }, []);
  return active ? <><Button disabled={disabled} title={disabled ? "Salvati modificarile pentru a deschide conditiile de scont." : "Deschide incasarile si conditiile de scont"} as={Link} variant="outline-primary" className="me-2 my-2"
    to={`/incasari-scont${invoiceId ? `?factura=${invoiceId}` : ''}`}>Încasări și scont</Button>{disabled && <small className="text-muted">Salvati modificarile pentru a deschide conditiile de scont.</small>}</> : null;
}

export function ReceivablesSettings() {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState('');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    authFetch('/incasari-scont/config').then(c => { if (alive) setConfig(c); })
      .catch(() => { /* Older backend: the optional feature is unavailable. */ });
    return () => { alive = false; };
  }, []);
  if (!config?.can_manage) return null;
  const save = async () => {
    setBusy(true); setError('');
    try {
      setConfig(await authFetch('/incasari-scont/config', { method: 'PUT', body: JSON.stringify({
        enabled: !config.enabled, revision: config.revision, reason,
      }) }));
      setReason('');
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <Card className="mb-3"><Card.Body>
    <Card.Title>Încasări și scont</Card.Title>
    <p>Disponibil în toate variantele, activat inițial doar pentru SIMAUS. Stare: <strong>{config.enabled ? 'activ' : 'inactiv'}</strong>.</p>
    {!config.ready ? <Alert variant="info">Modulul necesită instalarea separată a schemei de date.</Alert> : <>
      <Form.Label htmlFor="scont-setting-reason">Motivul schimbării</Form.Label>
      <Form.Control id="scont-setting-reason" maxLength={500} value={reason} onChange={e => setReason(e.target.value)} disabled={busy}/>
      <Button className="mt-2" type="button" disabled={busy || reason.trim().length < 3} onClick={save}>
        {config.enabled ? 'Dezactivează pentru această firmă' : 'Activează pentru această firmă'}
      </Button>
      {config.enabled && <Button as={Link} className="mt-2 ms-2" variant="outline-primary" to="/incasari-scont">Deschide situația</Button>}
    </>}
    {error && <Alert className="mt-2" variant="danger">{error}</Alert>}
  </Card.Body></Card>;
}
